import { createContext } from "react";

const AppContext = createContext({});

const { Consumer, Provider } = AppContext;

export default AppContext;
export { Consumer, Provider };
